import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

interface HeroProps {
  personalInfo: {
    name: string;
    title: string;
    tagline: string;
    highlight: string;
    subtitle: string;
    currentRole: string;
  };
  serviceCards?: unknown;
}

const Hero: React.FC<HeroProps> = ({ personalInfo }) => {
  return (
    <section className="hero" id="home">
      <div className="hero-bg-gradient" />
      <div className="hero-blob hero-blob-right" />
      <div className="hero-blob hero-blob-left" />

      <div className="hero-content">
        <div className="hero-badge">{personalInfo.title}</div>

        <h1 className="hero-title">
          <span className="hero-title-line-1">أُحوِّل الأفكار</span>
          <span className="hero-title-line-2">
            إلى أنظمةٍ{' '}
            <span className="hero-title-highlight">
              موثوقة
              <span className="hero-title-underline" />
            </span>{' '}
            وحقيقية
          </span>
        </h1>

        <p className="hero-description">
          <span>أبني حلولاً متكاملةً من الواجهة للخادم وقواعد البيانات، لأنَّ الكود الجيد </span>
          <span className="hero-description-emphasis">يُحدِث الفرق</span>
          <span> — وهذا ما يُميِّزني</span>
        </p>

        <div className="hero-cta">
          <Link to="/about" className="hero-btn-about">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <circle cx="8" cy="5.5" r="2.5" stroke="currentColor" strokeWidth="1.4" />
              <path d="M2.5 13.5C2.5 10.74 4.96 9 8 9C11.04 9 13.5 10.74 13.5 13.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
            </svg>
            من أنا
          </Link>
          <a href="#contact" className="hero-btn-primary">
            تواصل معي
          </a>
          <a href="#projects" className="hero-btn-secondary">
            اكتشف أعمالي
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M10 4L6 8L10 12" stroke="#0369A1" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>

        <div className="hero-stats">
          <div className="hero-stat">
            <div className="hero-stat-value">٤+</div>
            <div className="hero-stat-label">سنوات خبرة</div>
          </div>
          <div className="hero-stat hero-stat-border">
            <div className="hero-stat-value">٢٠+</div>
            <div className="hero-stat-label">مشروع منجز</div>
          </div>
          <div className="hero-stat">
            <div className="hero-stat-value">٤</div>
            <div className="hero-stat-label">شركات</div>
          </div>
          <div className="hero-stat hero-stat-border">
            <div className="hero-stat-value">٢</div>
            <div className="hero-stat-label">درجتان علميتان</div>
          </div>
        </div>
      </div>

      <div className="hero-scroll-indicator" aria-hidden="true">
        <div className="hero-scroll-dot" />
      </div>
    </section>
  );
};

export default Hero;
